module.exports = __webpack_public_path__ + "static/img/3.2aa0415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/3.jpg
// module id = VBZ/
// module chunks = 1